// AI Generated Component
import { Component, Input, OnInit } from '@angular/core';
import { SessionService } from '@monsido/core/session/session.service';

@Component({
    selector: 'page-details-policy-information-image',
    standalone: false,
    template: `
        <div class="page-details-policy-information">
            <table class="table policy-infomation-image">
                <tr *ngFor="let image of model.matches; trackBy: trackByIndex"
                    [attr.aria-label]="'Link to image' | translate">
                    <td class="col-8"
                        [attr.aria-label]="'Visit the affected image' | translate">
                        <a [href]="image | fullUrl:domainUrl:domainUrl"
                           target="_blank"
                           aria-describedby="linkOpensInNewTab">
                            <img [src]="image | fullUrl:domainUrl:domainUrl"
                                 [alt]="'Affected image' | translate"
                                 class="img-responsive img-thumbnail"
                            >
                        </a>
                    </td>
                    <td class="col-40"
                        [attr.aria-label]="'Visit the affected image' | translate">
                        <a [href]="image | fullUrl:domainUrl:domainUrl"
                           target="_blank"
                           aria-describedby="linkOpensInNewTab"
                        >
                            {{ image }}
                        </a>
                    </td>
                </tr>
            </table>
        </div>
    `,
})
export class PageDetailsPolicyInformationImageComponent implements OnInit {
    @Input() model: any;
    domainUrl: any;

    constructor (private sessionService: SessionService) {}

    ngOnInit (): void {
        this.domainUrl = this.sessionService.domain?.url;
    }

    trackByIndex (index: number): number {
        return index;
    }
}
